interface CalendlyLinkEntry {
  screeningCalendlyLink?: string;
  upskillingCalendlyLink?: string;
}

interface ResolvedCalendlyLinks {
  screeningCalendlyLink: string;
  upskillingCalendlyLink: string;
}

export function resolveCalendlyLinks(
  calendlyLinksMap: Record<string, CalendlyLinkEntry>,
  workplaceType: string | undefined
): ResolvedCalendlyLinks {
  const defaults = calendlyLinksMap.default ?? {};
  const overrides = workplaceType ? (calendlyLinksMap[workplaceType] ?? {}) : {};
  const resolved = { ...defaults, ...overrides };

  return {
    screeningCalendlyLink: resolved.screeningCalendlyLink ?? "",
    upskillingCalendlyLink: resolved.upskillingCalendlyLink ?? "",
  };
}
